import { tokens as r } from "./atoms-v257.js";
var o, e;
const t = (e = (o = r) == null ? void 0 : o.breakpoints) == null ? void 0 : e.queries;
export {
  t as breakpoints
};
